import React from "react"
import { connect } from "react-redux"

import AccordionNested from "../../components/global/accordionNested"

import branding_icon from "../../images/icon/icon-branding.svg"
import design_icon from "../../images/icon/icon-design.svg"
import collaboration_icon from "../../images/icon/icon-collaboration.svg"
import storytelling_icon from "../../images/icon/icon-storytelling.svg"
import retail_icon from "../../images/icon/icon-retail.svg"
import editorial_icon from "../../images/icon/icon-editorial.svg"
import mpl_icon from "../../images/icon/icon-mpl.svg"

const WhatWeDo = ({ mobile }) => {
  let capabilities = [
    {
      id: "branding",
      title: "Branding",
      icon: branding_icon,
      width: 50,
      mobile_width: 30,
      body:
        "From Naming to Brand Positioning to Graphic Identities and Logo Creation, we are experts in creating unique and compelling visual identities. These include all key elements across the mediums that embody the DNA of a successful brand.",
    },
    {
      id: "design",
      title: "Design & Development",
      icon: design_icon,
      width: 45,
      mobile_width: 27,
      body:
        "With our heritage in apparel, footwear and accessories, we can rightfully claim to be soft goods experts. We have also designed products and packaging for nearly every category; from hardgoods to technical to experiential to food and beverage. In addition, we have the resources and relationships to oversee production as well.",
    },
    {
      id: "collaboration",
      title: "Collaboration Curation",
      icon: collaboration_icon,
      width: 50,
      mobile_width: 30,
      body:
        "With our eyes and ears constantly focused on what’s bubbling up in our culture, we offer unique global insights on how to craft a strategy that ensures the right mix and cadence of collaborative partners. In addition, we offer the connections and experience to oversee negotiation, design+development and talent management.",
    },
    {
      id: "storytelling",
      title: "Storytelling",
      icon: storytelling_icon,
      width: 55,
      mobile_width: 33,
      body:
        "Great marketing starts with exceptional storytelling and we consider ourselves expert story-shapers, able to not only craft the vision, but also to help our partners pull the right marketing levers to bring that narrative to life via effective activations and executions.",
    },
    {
      id: "retail",
      title: "Retail Strategy",
      icon: retail_icon,
      width: 50,
      mobile_width: 30,
      body:
        "Our experience in creating innovative retail formats and working with retailers across the world allows us to build tailored product assortments and develop merchandising strategies ensuring the right product finds its way to the desired target consumers.",
    },
    {
      id: "editorial",
      title: "Editorial",
      icon: editorial_icon,
      width: 50,
      mobile_width: 30,
      body:
        "Shaping the editorial voice is essential for the end consumer to truly believe in the brand & we are adept at identifying a brand’s voice and producing customized content that delivers creative & on-brand editorial from photography to film to podcasting.",
    },
    {
      id: "mpl",
      title: "MPL",
      icon: mpl_icon,
      width: 50,
      mobile_width: 30,
      body:
        "We have the ability to provide a full range of services from design, sourcing, merchandising, production, go-to-market strategy as well as career management. These are all essential to launch, build and maintain a successful business. We are able to customize those MPL services to empower brands, creatives, influencers of all sizes to bring their ideas to reality.",
    },
  ]

  return (
    <div id="whatWeDo">
      {capabilities.map((i, idx) => {
        return (
          <AccordionNested key={idx} id={i.id}>
            <h1 className="title">
              <img
                src={i.icon}
                alt=""
                className="icon"
                width={mobile ? i.mobile_width : i.width}
              />
              <span>{i.title}</span>
            </h1>

            <h1 className="body">{i.body}</h1>
          </AccordionNested>
        )
      })}
    </div>
  )
}

export default connect(
  state => ({ mobile: state.global.mobile }),
  null
)(WhatWeDo)
